<form [formGroup]="searchForm" class="search-referral">
  <div class="page-header">Search referral</div>
  <p>Please input the referral information in the search text box</p>
  <div class="row">
    <div class="col-12 col-md-3 offset-md-1 form-group">
      <mat-form-field>
        <mat-label>Search</mat-label>
        <input matInput formControlName="searchText" />
      </mat-form-field>
    </div>
    <div class="form-group col-6 col-md-2">
      <mat-form-field>
        <input matInput [matDatepicker]="fromDate" formControlName="fromDate" placeholder="Start" />
        <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
        <mat-datepicker panelClass="greengo" #fromDate></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="form-group col-6 col-md-2">
      <mat-form-field>
        <input matInput [matDatepicker]="toDate" formControlName="toDate" placeholder="End" />
        <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
        <mat-datepicker panelClass="greengo" #toDate></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="form-group col-12 col-md-2">
      <button class="btn btn-block btn-lg btn-greengo" (click)="getSearchData()" [ngClass]="{
      'btn-greengo': !(searchForm.get('fromDate').value && searchForm.get('toDate').value && searchForm.get('fromDate').value > searchForm.get('toDate').value),
      'btn-inactive': searchForm.get('fromDate').value && searchForm.get('toDate').value && searchForm.get('fromDate').value > searchForm.get('toDate').value
    }" npFocusOutClicked>Search</button>
    </div>
  </div>
    <ng-table-pagination 
      [rows]="rows" 
      [columns]="columns" 
      [totalItems]="totalItems"
      (tableChanged)="getReferrals($event)">
    </ng-table-pagination>
</form>